if (sessionStorage.getItem('accessability') === '1') {
    specialActivate();
}

$_pro(() => {
    if (sessionStorage.getItem('accessability') === '1') {
        $_pro('#pro-special-menu').show();
        hideMenuHeaderAndFooter();
    }
    $_pro('body').on('click', '.accessability', function () {
        const body = $_pro('body');
        const accessability = sessionStorage.getItem('accessability');
        if (accessability === '1') {
            sessionStorage.setItem('accessability', 0);
            body.removeClass('special-version-on special-font-size-normal special-font-size-big '
                + 'special-font-size-large special-site-color-black-white special-site-color-white-black '
                + 'special-site-color-darkblue-blue special-font-family-arial special-font-family-times-new-roman '
                + 'special-letter-spacing-normal special-letter-spacing-big special-letter-spacing-large');
            $_pro('#pro-special-menu').hide();
            showMenuHeaderAndFooter();
        } else {
            sessionStorage.setItem('accessability', 1);
            specialActivate();
            $_pro('#pro-special-menu').show();
            hideMenuHeaderAndFooter();
        }
        $_pro(this).trigger('accessability');
    });
});

function specialActivate() {
    const body = $_pro('body');
    let specialFontSize = sessionStorage.getItem('special-font-size');
    let specialSiteColor = sessionStorage.getItem('special-site-color');
    let specialFontFamily = sessionStorage.getItem('special-font-family');
    let specialLetterSpacing = sessionStorage.getItem('special-letter-spacing');

    if (specialFontSize === null) {
        sessionStorage.setItem('special-font-size', 1);
        specialFontSize = '1';
    }
    if (specialSiteColor === null) {
        sessionStorage.setItem('special-site-color', 1);
        specialSiteColor = '1';
    }
    if (specialFontFamily === null) {
        sessionStorage.setItem('special-font-family', 1);
        specialFontFamily = '1';
    }
    if (specialLetterSpacing === null) {
        sessionStorage.setItem('special-letter-spacing', 1);
        specialLetterSpacing = '1';
    }

    body.addClass('special-version-on');
    if (specialFontSize === '1') {
        body.addClass('special-font-size-normal');
        $_pro('#special-font-size-normal').addClass('special-btn-active');
    } else if (specialFontSize === '2') {
        body.addClass('special-font-size-big');
        $_pro('#special-font-size-big').addClass('special-btn-active');
    } else if (specialFontSize === '3') {
        body.addClass('special-font-size-large');
        $_pro('#special-font-size-large').addClass('special-btn-active');
    }

    if (specialSiteColor === '1') {
        body.addClass('special-site-color-black-white');
        $_pro('#special-site-color-black-white').addClass('special-btn-active');
    } else if (specialSiteColor === '2') {
        body.addClass('special-site-color-white-black');
        $_pro('#special-site-color-white-black').addClass('special-btn-active');
    } else if (specialSiteColor === '3') {
        body.addClass('special-site-color-darkblue-blue');
        $_pro('#special-site-color-darkblue-blue').addClass('special-btn-active');
    }

    if (specialFontFamily === '1') {
        body.addClass('special-font-family-arial');
        $_pro('#special-font-family-arial').addClass('special-btn-active');
    } else if (specialFontFamily === '2') {
        body.addClass('special-font-family-times-new-roman');
        $_pro('#special-font-family-times-new-roman').addClass('special-btn-active');
    }

    if (specialLetterSpacing === '1') {
        body.addClass('special-letter-spacing-normal');
        $_pro('#special-letter-spacing-normal').addClass('special-btn-active');
    } else if (specialLetterSpacing === '2') {
        body.addClass('special-letter-spacing-big');
        $_pro('#special-letter-spacing-big').addClass('special-btn-active');
    } else if (specialLetterSpacing === '3') {
        body.addClass('special-letter-spacing-large');
        $_pro('#special-letter-spacing-large').addClass('special-btn-active');
    }
}

function hideMenuHeaderAndFooter() {
    $_pro('#pro-nav-left, #pro-nav-right, #pro-header, #pro-menu-top, #pro-footer').hide();
    $_pro('#pro-nav-special').show();
    const proContent = $_pro('#pro-content');
    if (!proContent.hasClass('abitur')) {
        proContent.removeClass('col-xs-12').addClass('col-lg-10 col-md-9 col-sm-8');
    }
}

function showMenuHeaderAndFooter() {
    $_pro('#pro-header, #pro-menu-top, #pro-footer').show();
    $_pro('#pro-nav-special').hide();

    if ($_pro('#pro-nav-left #nav-menu').length > 0) {
        $_pro('#pro-nav-left').show();
    }
    if ($_pro('#pro-nav-right #nav-menu').length > 0) {
        $_pro('#pro-nav-right').show();
    }
    if ($_pro('#pro-nav-left #nav-menu').length == 0 && $_pro('#pro-nav-right #nav-menu').length == 0) {
        $_pro('#pro-content').removeClass('col-lg-10 col-md-9 col-sm-8').addClass('col-xs-12');
    }
}
